import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import { InputContext } from '../../contexts/InputContext';
import MessageModal from '../../container/MessageModal';
import TextControl from '../../container/customizedInputs/TextControl';
import { errorClassification } from '../../errorHandler';

import resourcesServices from '../../services/resourcesServices';

const MaterialEstudioForm = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [materialEstudio, setMaterialEstudio] = useState({});
  const [esNuevo, setEsNuevo] = useState(true);
  const [renderHTML, setRenderHTML] = useState(false);

  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };

  let { id } = useParams();

  useEffect(() => {
    setEsNuevo( id === undefined )

    if(id){
      fetchMaterialEstudio(id)
    } else {
      nuevaMaterialEstudio()
    }
  }, [id]);

  useEffect(() => {

    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( (authInformation.autenticado === true) && (authInformation.rol === 'Admin')){
      setRenderHTML(true)
    } else if( (authInformation.autenticado === true) && (authInformation.rol !== 'Admin')){
      navigate(`/`);
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);

  const fetchMaterialEstudio = async (id) => {
    try {
      const data = await resourcesServices.obtenerResourcePorId('material_estudios', id);
      setMaterialEstudio(data);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const nuevaMaterialEstudio = async (id) => {
    try {
      // const data = await resourcesServices.nuevoResource('material_estudios');
      // setMaterialEstudio(data);
      setMaterialEstudio({nombre: '', archivoUrl: ''});


    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const guardarMaterialEstudio = async () => {
    try {
      let data;

      if(esNuevo){
        data = await resourcesServices.crearResource('material_estudios', {material_estudio: materialEstudio}, true);
      } else {
        data = await resourcesServices.actualizarResource('material_estudios', materialEstudio.id, {material_estudio: materialEstudio}, true);
      }

      setMaterialEstudio(data);

      handleShowModal("Datos actualizados")
      if(esNuevo){
        navigate(`/material_estudio/${data.id}/edit`);
      }

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setMaterialEstudio({...materialEstudio,
        [name]: value
    })
  }

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setMaterialEstudio({...materialEstudio,
      [name]: files[0]
    })
  };

  const handleFormSubmit = (e) => {
    e.preventDefault()

    guardarMaterialEstudio()
  }

  return (
    <>
      {
        renderHTML && (
          <main className="w-100 m-auto" style={{maxWidth: '660px'}}>
            <form>
              {/* <pre>{JSON.stringify(materialEstudio, null, 2)}</pre> */}
              <TextControl
                className='mb-3'
                value={materialEstudio.nombre}
                name={'nombre'}
                handleInput={handleInput}
              />

              <div className="card mb-3">
                <div className="card-body">
                <h5 className="card-title">Suba el archivo</h5>
                {
                  materialEstudio.imageUrl && (
                    materialEstudio.archivoUrl
                  )
                }

                <div className="mb-3">
                  <input placeholder="Adjunte el archivo" className="form-control" onChange={handleFileChange} name="archivo" type="file" id="archivo" />
                </div>

                </div>
              </div>


              <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                <button className="btn btn-primary w-100 py-2" onClick={handleFormSubmit} type="submit">Guardar</button>
                <button className="btn btn-outline-secondary px-4" type='button' onClick={() => navigate(-1)}>Volver</button>
              </div>

            </form>
          </main>
        )
      }

     <MessageModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalBody={modalBody}
     />
    </>
  );
};

export default MaterialEstudioForm;